/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2020, Zumper
 * @description multifamilyTourTimePicker constants
 */

export const ERROR_FETCHING_TOUR_AVAILABILITY =
  '@@nzr/multifamilyTourTimePicker/ERROR_FETCHING_TOUR_AVAILABILITY'
export const ERROR_FETCHING_TOUR_INTEGRATION =
  '@@nzr/multifamilyTourTimePicker/ERROR_FETCHING_TOUR_INTEGRATION'
export const RECEIVE_SELECTED_DATETIME = '@@nzr/multifamilyTourTimePicker/RECEIVE_SELECTED_DATETIME'
export const RESET_SELECTED_DATETIME = '@@nzr/multifamilyTourTimePicker/RESET_SELECTED_DATETIME'
export const RECEIVE_SELECTED_TOUR_TYPE =
  '@@nzr/multifamilyTourTimePicker/RECEIVE_SELECTED_TOUR_TYPE'
export const RECEIVE_TOUR_AVAILABILITY = '@@nzr/multifamilyTourTimePicker/RECEIVE_TOUR_AVAILABILITY'
export const RECEIVE_TOUR_INTEGRATION = '@@nzr/multifamilyTourTimePicker/RECEIVE_TOUR_INTEGRATION'
export const START_FETCHING_TOUR_AVAILABILITY =
  '@@nzr/multifamilyTourTimePicker/START_FETCHING_TOUR_AVAILABILITY'
export const START_FETCHING_TOUR_INTEGRATION =
  '@@nzr/multifamilyTourTimePicker/START_FETCHING_TOUR_INTEGRATION'
export const START_SUBMITTING = '@@nzr/multifamilyTourTimePicker/START_SUBMITTING'
export const DONE_SUBMITTING = '@@nzr/multifamilyTourTimePicker/DONE_SUBMITTING'
